module.exports = __webpack_public_path__ + "img/cctv.4ff7112d.jpg";